import React, { useEffect, useState } from "react";
import { Box, Heading, Text } from "grommet";
import { ReportHeader } from "../../components/QuizResultsComponents/ReportHeaeder";
import { LearningPath } from "../../components/QuizResultsComponents/LearningPath";
// import { ProgressTracking } from "../../components/QuizResultsComponents/ProgressTracking";
// import { ManagerialInsights } from "../../components/QuizResultsComponents/ManagerialInsights";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { quizResultsData as sampleData } from "../../components/QuizResultsComponents/sampleQuizData";
import { useNavigate } from "react-router-dom";
import { LinkPrevious } from "grommet-icons";
import { ProductsAssessment } from "../../components/QuizResultsComponents/ProductsAssessment";
import { useParams } from "react-router-dom";
import axios from "axios";
import API_URL from "../../config/config";
import { DigitalLearningPath } from "../../components/QuizResultsComponents/DigitalLearningPath";
import { DedicatedLearningButton } from "../../components/Buttons/DedicatedLearning";
import UserAssessmentDetails from "../../components/Dashboard/UserAssessmentsDetails";
const QuizResultsForDashboard = () => {
  const { user_id, assessment_id } = useParams();
  const [name, setName] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}/user/getUserNameById/${user_id}`);
        setName(response.data.name ?? "");
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [user_id]);

  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />

        <Box
          align="center"
          pad={{ horizontal: "medium", vertical: "medium" }}
          margin={{ horizontal: "small", vertical: "medium" }}
        >
          <Box alignSelf="start">
            <LinkPrevious
              onClick={() => {
                navigate(-1);
              }}
              size="large"
              color="brand"
            />
          </Box>
          <Box alignSelf="center" alignContent="center" align="center">
            <Text size="large" weight="bold" margin={{ bottom: "small" }}>
              Skills summary report
            </Text>
            <Text size="medium" margin={{ bottom: "medium" }}>
              You have completed your assessment. Below are the recommendations
              based on your previous assessments.
            </Text>
          </Box>

          <Box width="100%" pad={{ horizontal: "medium" }}>
            <Box border={{ color: "brand", size: "small" }}>
              <Box
                pad="medium"
                direction="column"
                justify="between"
                align="center"
              >
                {/* <Heading level="1">Assessment history</Heading> */}
                <UserAssessmentDetails user_id={user_id} />
              </Box>
              <Box
                direction="row"
                pad="medium"
                align="center" // Align the items to the center
                alignContent="center" // Align the content to the center
                alignSelf="center" // Align the box to the center
              >
                <DedicatedLearningButton user_id={user_id} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};

export default QuizResultsForDashboard;
